export default __webpack_public_path__ + "media/images/yukiho-5b26f6e3a83cb199bb7854b53c6ac27d.png";